import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import {
    Button, Col
} from "reactstrap";


export default function ButtonFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, resetField } = formManager;//, setValue, errors


    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_fail"),
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //TEMP : PB réactualisation bg button
        var backgroundRequired = document.querySelectorAll("[data-backimage]");
        backgroundRequired.forEach((node) => {
            node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
            node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
        });

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);



    var onClick = (e) => {
        if (e && data.subType !== "phone") e.preventDefault();
        if (!disabled) {
            // /!\ Utilisé dans le modèle DLG_REPORTS
            switch (data.subType) {
                case "cloneGroup":
                    if (data.src) {
                        modelFctManager.onActionRequired(data.name, { trigger: "findFragment", target: data.src }, data).then(actionResponse => {
                            //console.debug("RESPONSE");
                            //console.debug(actionResponse);
                            if (actionResponse) {
                                if (!actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: actionResponse.errorMessage
                                    });
                                }
                                else if (actionResponse.result) {
                                    var target = actionResponse.result;
                                    var header = target.functionManager.getParent();

                                    var cloneElem = JSON.parse(JSON.stringify(target));
                                    cloneElem.key = null;
                                    cloneElem.isModel = false;
                                    cloneElem.isExcluded = false;
                                    cloneElem.clonable = false;
                                    cloneElem.hidden = false;
                                    cloneElem.temporary = true;//echo à isCloned mais défini si l'élément doit être supprimé au chargement

                                    header.groups.push(cloneElem);//TODO : voir pour ajotuer les éléments juste après le modele
                                    header.functionManager.rerender();
                                }
                            }
                        });
                    }
                    else {
                        var target = parentProps.parentData.functionManager.getParent();
                        var index = target.groups.indexOf(parentProps.parentData);
                        if (index >= 0) {
                            target.groups.splice(index, 1);
                        }
                        target.functionManager.rerender();
                    }
                    break;
                case "removeItem":
                    //parentProps.childs = parentProps.childs.filter((elem) => elem !== data);
                    var indexRI = parentProps.childs.indexOf(data);
                    if (indexRI >= 0) {
                        parentProps.childs.splice(indexRI, 1);
                    }
                    if (data.src) {
                        //TODO : supprimer la cible
                    }
                    break;
                case "removeGroup":
                    //parentProps.childs = parentProps.childs.filter((elem) => elem !== data);
                    var indexRG = parentProps.childs.indexOf(data);
                    if (indexRG >= 0) {
                        parentProps.childs.splice(indexRG, 1);
                    }
                    if (data.src) {
                        //TODO : supprimer la cible
                    }
                    else {
                        resetField(commonFunc.camelize(parentProps.parentData.bindPropResult, true) + "[" + parentProps.parentData.key + "]");

                        var targetRG = parentProps.parentData.functionManager.getParent();
                        indexRG = targetRG.groups.indexOf(parentProps.parentData);
                        if (indexRG >= 0) {
                            targetRG.groups.splice(indexRG, 1);
                        }
                        targetRG.functionManager.rerender();
                    }
                    break;
                default:
                    break;
            }

            if (data.onActionEvents && data.onActionEvents["onClick"]) {
                data.onActionEvents["onClick"].forEach((args, index) => {
                    //args.value / args.target
                    modelFctManager.onActionRequired(data.name, args, data, data.argumentsObj, e).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_fail"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        }
    };

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.performClick = () => { onClick() };

    register(bindPropResult);

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { overflow: "hidden" };
    var containerStyle = {};
    var frameClass = "";
    var frameStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        switch (data.checkRights.action) {
            case "disabled":
                if (!hasRights) disabled = true;
                break;
            case "invisible":
                if (!hasRights) frameClass += " invisible";
                break;
            default:
                if (!hasRights) frameClass += " d-none";
                break;
        }
    }
    if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length === 0 || (data.children.length === 1 && data.children[0].objType !== "itemsContainer"))) btnSupClass += " btn-icon ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_button");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        var marginElevation = 0;
        if (design.elevation) {
            btnStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
            marginElevation = parseInt(design.elevation.replace("px", ""));
        }

        //btnStyle.margin = design.margin;
        var margin = design.margin ? parseInt(design.margin.replace("px", "")) : -1;
        var marginTop;
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                marginTop = parseInt(design.marginTop.replace("px", ""));
            }
            else {
                btnSupClass += design.marginTop;
            }
        }
        else {
            marginTop = margin;
        }
        var marginLeft = design.marginStart ? parseInt(design.marginStart.replace("px", "")) : margin;
        var marginBottom = design.marginBottom ? parseInt(design.marginBottom.replace("px", "")) : margin;
        var marginRight = design.marginEnd ? parseInt(design.marginEnd.replace("px", "")) : margin;

        if (marginLeft !== -1 || marginTop !== -1 || marginRight !== -1 || marginBottom !== -1) {
            if (marginTop !== -1) btnStyle.marginTop = (marginTop + marginElevation) + "px";
            if (marginRight !== -1) btnStyle.marginRight = (marginRight + marginElevation) + "px";
            if (marginBottom !== -1) btnStyle.marginBottom = (marginBottom + marginElevation) + "px";
            if (marginLeft !== -1) btnStyle.marginLeft = (marginLeft + marginElevation) + "px";
        }
        else {
            btnStyle.margin = marginElevation + "px";
        }
        if (design.margin) {
            btnClass = btnClass.replace("m-1", "");
        }

        if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));

        Object.assign(btnStyle, modelFctManager.managePadding(design, btnClass));
    }
    if (data.customDesign?.extrasDesign?.containerDesign) {
        Object.assign(containerStyle, modelFctManager.setCustomBackground(data.customDesign.extrasDesign.containerDesign, data));
    }

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";


    if (data.groupSubName?.startsWith("containerGroup")) frameClass += " c-container-btn ";

    var optAttr = {};
    if (data.subType === "phone") optAttr.href = `callto:${data.defaultValue}`;

    var baseForm;
    if (data.groupSubName === "header") {//TODO : check si conservation OU alternative
        baseForm = <a href="/" className={`float-start me-2 widget-action-icon ${btnSupClass} ${data.classSup}`} style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null} onClick={onClick} title={altT(data.title)} {...optAttr}>
            {childs}
        </a>;
    }
    else {
        var configAttr = (isConfiguration ? {} : {});
        if (isConfiguration && data.groupSubName?.startsWith("containerGroup")) btnStyle.pointerEvents = "none";
        baseForm = <Button color="none" className={`btn-sm ${btnClass} ${btnSupClass} ${data.classSup} ${data.customDesign?.extrasDesign?.containerDesign ? "p-0" : ""}`} style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null}
            disabled={disabled} onClick={onClick} {...configAttr} {...optAttr}>
            <div style={containerStyle} data-backimage={containerStyle.hasImage || null} data-imageopacity={containerStyle.alpha || null}>
                {(!design?.position || design?.position === "start" || design?.position === "left") ? childs : ""}
                {altT(data.title)}
                {(design?.position === "right" || design?.position === "end") ? childs : ""}
            </div>
        </Button>;
    }
    return <Col data-name="ButtonFrag" data-element={data.objType} data-bind={bindPropResult} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}